/**
 * Execute page-specific JavaScript code
 */

import collection from './collection'
import home from './home'

export const pages = [
    {
        id: 'home',
        init: home,
    },
    {
        id: 'collection',
        init: collection,
    },
]

// Page will run specific JS if found the page #{id}
function pageRunners() {
    for (const page of pages) {
        const isBodyId = document.body.id == page.id
        if (isBodyId) {
            return page.init()
        }
    }
}

export default pageRunners
